import RefreshIcon from '@mui/icons-material/Refresh'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { Submission } from '@global/types'
import { GoogleAnalyticsExecution } from './GoogleAnalyticsExecution'
import * as css from './styles'
import {
  IDatasetIntegrationExecution,
  IDatasetIntegrationExecutions,
} from '../../../datasetHistoryV2/types'
import { RootState } from 'redux/store'
import { t } from '@lingui/core/macro'

interface Props {
  loading: boolean
  executions: IDatasetIntegrationExecutions
  submission: Submission
  refreshGAIntegrationStatus: (execution: IDatasetIntegrationExecution) => void
  downloadIntegration: (execution: IDatasetIntegrationExecution) => void
  rerunIntegration: (execution: IDatasetIntegrationExecution, submission: Submission) => void
}

export const Executions = ({
  loading,
  executions,
  submission,
  refreshGAIntegrationStatus,
  downloadIntegration,
  rerunIntegration,
}: Props) => {
  const RERUN_INTEGRATIONS_ENABLED = useSelector(
    (state: RootState) => state.Auth.features['rerun-integrations-button'],
  )

  const submissionExecutions = Object.values(executions)

  return (
    <>
      {submissionExecutions.map(
        exec =>
          Boolean(exec?.integration_slug === 'google-analytics') && (
            <css.SubSection key={exec?.id}>
              <GoogleAnalyticsExecution
                loading={loading}
                execution={exec}
                refreshGAIntegrationStatus={refreshGAIntegrationStatus}
              />
            </css.SubSection>
          ),
      )}
      {submissionExecutions.map(exec => (
        <css.SubSection key={exec?.id}>
          <div css={css.flexItem}>{exec['Connector Name']}</div>
          <div css={css.flexItem}>
            <a
              onClick={() => {
                downloadIntegration(exec)
              }}
              style={{ cursor: 'pointer' }}
            >
              {exec['Created File']}
            </a>
          </div>
          {RERUN_INTEGRATIONS_ENABLED && (
            <div css={css.flexShrink}>
              <RefreshIcon
                onClick={() => {
                  rerunIntegration(exec, submission)
                }}
              />
            </div>
          )}
        </css.SubSection>
      ))}
      {submissionExecutions[0] && (
        <>
          <Typography variant="h6">{t`Integration error message`}</Typography>
          <css.IntegrationErrorMessage>
            {submissionExecutions[0]['Output Configuration Error']}
          </css.IntegrationErrorMessage>
        </>
      )}
    </>
  )
}
